export default __webpack_public_path__ + "static/hero-image-32a591f3f6b58c89ac4ac3d604e94333.png";